<script>
    import EmbeddableProductOffers from "./EmbeddableProductOffers.svelte";
    import {decode} from "html-entities";
    import SvelteSeo from "svelte-seo";
    import {onMount} from "svelte";

    export let config;
    export let mid;

    let isLoaded = false;
    let startDate = "";
    let endDate = "";

    // Benutzer nach Gültigkeitszeitraum fragen
    const askValidityPeriod = () => {
        startDate = prompt("Von wann sind die Angebote gültig? (z.B. 01.01.2025)", "");
        endDate = prompt("Bis wann sind die Angebote gültig? (z.B. 31.01.2025)", "");

        if (!startDate || !endDate) {
            alert("Bitte beide Daten eingeben!");
            askValidityPeriod(); // Wiederholen, falls keine Eingabe
        }
    };

    onMount(() => {
        askValidityPeriod(); // Gültigkeitszeitraum beim Laden abfragen

        // Simulierte Ladevorgang - in der Realität durch Daten laden ersetzen
        setTimeout(() => {
            isLoaded = true;
            printWindow();
        }, 5000); // Beispiel-Ladezeit
    });

    const printWindow = () => {
        setTimeout(() => {
            window.print();
        }, 50); // Beispiel-Ladezeit
    }

</script>

<SvelteSeo
        title="Aktuelle Angebote beim Dorfladen Gungolding"
/>

{#if !isLoaded}
    <div class="loading-overlay">
        <div class="spinner"></div>
        <p>Bitte warten, Angebote werden geladen...</p>
    </div>
{/if}

<article class="bg-transparent">

    <div class="my-5 pb-0 text-center">
        <h2 class="site-header">Aktuelle Angebote vom {startDate} bis {endDate}</h2>
    </div>
</article>

<EmbeddableProductOffers mid={mid} {config} />

<style>
    /* Ladeoverlay */
    .loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(255, 255, 255, 0.9); /* Halbtransparent */
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 1000; /* Über allem */
    }

    /* Spinner-Animation */
    .spinner {
        width: 50px;
        height: 50px;
        border: 5px solid rgba(0, 0, 0, 0.1);
        border-top: 5px solid #333;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }

    .loading-overlay p {
        margin-top: 20px;
        font-size: 1.2rem;
        color: #333;
    }
</style>
